import { AnyAction } from "@reduxjs/toolkit";
import * as AT from "./actionTypes";
import { VoucherState } from "../../../../models/state/voucher";
import { mapVoucherValidationErrorMessage, VoucherErrorCode } from "../validation";

const initialState: VoucherState = {
    validatedVouchers: [],
    validationMessage: undefined,
    code: "",
};

// See promise-middleware for more info
function fulfilled(actionType: keyof typeof AT) {
    return `${actionType}_FULFILLED`;
}

const reducer = (state = initialState, action: AnyAction): VoucherState => {
    switch (action.type) {
        case fulfilled(AT.VOUCHER_UPDATED):
        case fulfilled(AT.VOUCHER_ADD):
        case fulfilled(AT.VOUCHER_REMOVE):
            return {
                ...state,
                code: "",
                validatedVouchers:
                    action.payload.validatedVouchers !== undefined
                        ? action.payload.validatedVouchers
                        : state.validatedVouchers,
                validationMessage: action.payload.validationCode
                    ? (mapVoucherValidationErrorMessage(action.payload.validationCode as VoucherErrorCode) as string)
                    : "",
            };
        case AT.VOUCHER_ERROR:
            return {
                ...state,
                validationMessage: action.validationMessage,
            };
        case AT.VOUCHER_FORMAT_CODE:
            return {
                ...state,
                code: action.code,
            };
        default:
            return state;
    }
};

export default reducer;
